var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.994,
    height: 12.997,
    viewBox: "0 0 15.994 12.997",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_4",
    "data-name": 4,
    d: "M59.05,369.488l1.891-5.673a.553.553,0,0,0-.053-.545.848.848,0,0,0-.677-.28l-10.686,0-.285-1.356a.752.752,0,0,0-.763-.626L46,361c-.311,0-1.007.154-1.007.446L45,362a.9.9,0,0,0,1,1h2l1.96,7.843a1.884,1.884,0,0,0,1.3,3.132,1.979,1.979,0,0,0,1.756-1.407h3.779A1.851,1.851,0,0,0,58.546,374a1.82,1.82,0,0,0,1.771-1.826,1.736,1.736,0,0,0-3.094-1.178H52.579a1.47,1.47,0,0,0-1.263-.707l-.063-.344h7.066c.532,0,.637-.195.731-.453Zm-8.482,2.66a.673.673,0,1,1,.674.676A.676.676,0,0,1,50.568,372.147Zm7.992.667a.667.667,0,1,1,.666-.667A.667.667,0,0,1,58.56,372.815Z",
    transform: "translate(-44.993 -360.999)",
    fill: "#aaa"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cart-icon.f590fbc1.svg";
export { ForwardRef as ReactComponent };